import { render } from "./App.vue?vue&type=template&id=3c5ce318"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/vuexy/vendor/css/rtl/core.css?vue&type=style&index=0&lang=css&external"
import "./assets/vuexy/vendor/css/rtl/theme-default.css?vue&type=style&index=1&lang=css&external"
import "./assets/vuexy/vendor/fonts/tabler-icons.css?vue&type=style&index=2&lang=css&external"
import "./assets/vuexy/css/demo.css?vue&type=style&index=3&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__